<div class="cm-assigned-user" [style.color]="$nextActorLabel()?.background ?? 'black'" [matTooltip]="$assignedUserName() ?? ''">
    @if ($assignedUserName()) {
        <cm-user-thumbnail [user]="$user()"></cm-user-thumbnail>
    } @else {
        <i class="far fa-user-plus cm-assign-user"></i>
    }
</div>
